import moment from 'moment';
import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { TranslateService } from '../services/translate.service';
import { AuthService } from '../services/auth.service';

@Pipe({
  name: 'commentDate',
  pure: false,
  standalone: false,
})
@Injectable({
  providedIn: 'root',
})
export class CommentDatePipe implements PipeTransform {
  constructor(
    private readonly authService: AuthService,
    private readonly translateService: TranslateService
  ) {}

  transform(value: string, args?) {
    const { timeFormat = '12hs', timeDisplay } = this.authService.getAuthUserSettings();
    const lang = this.translateService.getLang();
    let dateFormat = this.authService.getUserSettings('dateFormat');
    if (!dateFormat) {
      dateFormat = 'DD/MM/YYYY';
    }
    /*
		let formattedTime = 'hh:mm a';
		if (timeFormat === '24hs') {
			formattedTime = 'HH:mm';
		}
		if (!dateFormat)
			dateFormat = 'YYYY-MM-DD';
		let isSameDay = moment().isSame(moment(value), 'day');
		if (lang === 'fr')
			return moment(value).format(isSameDay ? `[Aujourd\'hui à] ${formattedTime}` : `${dateFormat} [à] ${formattedTime}`);
		else
			return moment(value).format(isSameDay ? `[Today at] ${formattedTime}` : `${dateFormat} [at]  ${formattedTime}`);
		*/

    const jsTimeDisplay = args?.showTime ? timeDisplay.replace('MM', 'mm') : timeDisplay;
    return moment(value).format(dateFormat + (args?.showTime ? ' ' + jsTimeDisplay : ''));
  }
}
